import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["eventContainer", "tooltip"]

  connect() {
    // Initialize any necessary state
  }

  showTooltip(event) {
    const container = event.currentTarget
    const tooltip = container.querySelector('[data-admin-calendar-target="tooltip"]')
    
    if (tooltip) {
      // For mobile, show tooltip on hover/focus
      tooltip.classList.remove("invisible", "opacity-0")
      tooltip.classList.add("visible", "opacity-100")
      
      // Announce to screen readers
      this.announceEvent(tooltip)
    }
  }

  hideTooltip(event) {
    const container = event.currentTarget
    const tooltip = container.querySelector('[data-admin-calendar-target="tooltip"]')
    
    if (tooltip) {
      // On mobile, hide tooltip when not hovering/focused
      // On desktop (md+), tooltip remains visible
      if (window.innerWidth < 768) {
        tooltip.classList.add("invisible", "opacity-0")
        tooltip.classList.remove("visible", "opacity-100")
      }
    }
  }

  announceEvent(tooltip) {
    // Create an ARIA live region announcement for accessibility
    const eventName = tooltip.querySelector('.event-name')?.textContent
    const eventTime = tooltip.querySelector('.time')?.textContent
    
    if (eventName && eventTime) {
      const announcement = `Event: ${eventName}, ${eventTime}`
      
      // Update aria-label on the container for screen readers
      const container = tooltip.closest('[data-admin-calendar-target="eventContainer"]')
      if (container) {
        container.setAttribute('aria-label', announcement)
      }
    }
  }
}
